export default __webpack_public_path__ + "static/media/dinosaur.d31ce2f9.png";